(() => {
  'use strict';
  const dialog = document.querySelector('[data-ab9-dialog]');
  if (!dialog) return;
  const root = dialog.dataset.root || '/';
  const url = path => root + path.replace(/^\//, '');
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {style:'currency',currency:dialog.dataset.currency || 'AUD'}).format(value / 100);
  const $ = selector => dialog.querySelector(selector);
  let map = {}, product = null, family = [], selected = [], variant = null, opener = null, loading = 0;
  const cache = new Map();
  const dataReady = fetch(dialog.dataset.colourMap).then(r => r.ok ? r.json() : {}).then(data => { map = data; enhanceCards(); }).catch(() => {});
  function element(tag, props = {}, text) { const el=document.createElement(tag); Object.assign(el, props); if(text !== undefined) el.textContent=text; return el; }
  function cardData(card) { try { return JSON.parse(card.querySelector('[data-ab9-product-json]').getAttribute('data-ab9-product-json')); } catch(e) { return null; } }
  async function loadProduct(handle) {
    if (cache.has(handle)) return cache.get(handle);
    const response=await fetch(url('products/' + encodeURIComponent(handle) + '.js'), {credentials:'same-origin'});
    const data=await response.json(); if(!response.ok) throw new Error(data.description || 'Product unavailable. Please view full details.');
    cache.set(handle,data); return data;
  }
  function images(p) { return (p.images || []).map(x => typeof x === 'string' ? x : x.src).filter(Boolean); }
  function options(p) { return (p.options || []).map((o,i) => typeof o === 'string' ? {name:o,values:[...new Set(p.variants.map(v=>v.options[i]))]} : o); }
  function setStatus(message) { $('[data-ab9-status]').textContent=message; }
  function findVariant() { variant=product.variants.find(v=>v.options.every((o,i)=>o===selected[i])); return variant; }
  function updatePurchase() {
    findVariant(); const add=$('[data-ab9-add]');
    add.disabled=!variant || !variant.available;
    add.firstChild.textContent=variant ? (variant.available ? 'Add to cart ' : 'Sold out ') : 'Select size ';
    $('[data-ab9-price]').textContent=money(variant ? variant.price : product.price);
  }
  function renderOptions() {
    const host=$('[data-ab9-options]'); host.replaceChildren();
    options(product).forEach((o,i)=> {
      if(o.name === 'Title' && o.values.length === 1 && o.values[0] === 'Default Title') { selected[i]=o.values[0]; return; }
      const group=element('div',{className:'ab9-option-group'});
      if(!/size/i.test(o.name)) group.append(element('span',{},o.name));
      const values=element('div',{className:'ab9-option-values'}); values.setAttribute('role','group'); values.setAttribute('aria-label',o.name);
      o.values.forEach(value=> {
        const button=element('button',{type:'button'},value);
        button.setAttribute('aria-pressed',selected[i]===value ? 'true':'false');
        button.disabled=!product.variants.some(v=>v.available && v.options[i]===value && v.options.every((val,j)=>j===i || !selected[j] || selected[j]===val));
        button.addEventListener('click',()=>{selected[i]=value; renderOptions(); updatePurchase();}); values.append(button);
      }); group.append(values); host.append(group);
    }); updatePurchase();
  }
  function renderColours() {
    const host=$('[data-ab9-colours]');host.replaceChildren();
    const siblings=map[product.handle] || family;
    const current=siblings.find(x=>x.handle===product.handle);
    $('[data-ab9-colour-name]').textContent=current?.colour || (product.title.includes('|') ? product.title.split('|').pop().trim() : '');
    siblings.forEach(x=> {
      const button=element('button',{type:'button',title:x.colour});button.setAttribute('aria-label',x.colour);button.setAttribute('aria-pressed',x.handle===product.handle ? 'true':'false');
      const dot=element('span',{className:'ab9-colour-dot'});dot.style.background=x.hex;button.append(dot,element('small',{},x.colour));
      button.addEventListener('click',async()=>{ if(x.handle===product.handle)return; const seq=++loading;setStatus('Loading colour…'); $('[data-ab9-add]').disabled=true;
        try{const p=await loadProduct(x.handle);if(seq!==loading)return;renderProduct(p);setStatus('');}catch(e){setStatus(e.message);updatePurchase();}
      });host.append(button);
    });
    host.hidden=siblings.length===0;
  }
  function renderProduct(p) {
    product=p;selected=Array(options(p).length).fill(null);variant=null;
    options(p).forEach((o,i)=>{if(o.values.length===1)selected[i]=o.values[0];});
    $('[data-ab9-title]').textContent=p.title.split('|')[0].trim();
    $('[data-ab9-details]').href=url('products/'+p.handle);
    const gallery=$('[data-ab9-gallery]');gallery.replaceChildren();
    images(p).slice(0,6).forEach(src=>gallery.append(element('img',{src,alt:p.title,loading:'eager'})));
    renderColours();renderOptions();setStatus('');
  }
  function close() { dialog.close(); document.documentElement.classList.remove('ab9-modal-open'); if(opener?.isConnected)opener.focus(); }
  async function open(button) {
    opener=button; const handle=button.dataset.ab9Open;
    const local=cardData(button.closest('.product-block'));
    if(local)cache.set(handle,local);
    await dataReady; family=map[handle] || [];renderProduct(local || await loadProduct(handle));
    dialog.showModal();document.documentElement.classList.add('ab9-modal-open');$('[data-ab9-close]').focus();
    // Re-check availability from live Shopify data; cached inline data is initial display only.
    const seq=++loading;
    fetch(url('products/'+encodeURIComponent(handle)+'.js'),{credentials:'same-origin'}).then(r=>r.ok?r.json():null).then(p=>{if(p && seq===loading){cache.set(handle,p);if(!selected.some(Boolean))renderProduct(p);else{product=p;renderOptions();}}}).catch(()=>{});
  }
  $('[data-ab9-close]').addEventListener('click',close);
  dialog.addEventListener('cancel',event=>{event.preventDefault();close();});
  dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)close();}});
  $('[data-ab9-add]').addEventListener('click',async()=> {
    if(!findVariant()?.available)return;const add=$('[data-ab9-add]');add.disabled=true;setStatus('Adding to cart…');
    try {
      const response=await fetch(url('cart/add.js'),{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variant.id,quantity:1}]})});
      const result=await response.json();if(!response.ok)throw new Error(result.description || 'This size is unavailable. Choose another size.');
      setStatus('Added to cart.');
      const cart=await fetch(url('cart.js'),{credentials:'same-origin'}).then(r=>r.json());
      document.querySelectorAll('.cart-link__count').forEach(el=>{el.textContent=cart.item_count;});
      document.dispatchEvent(new CustomEvent('ab:cart:updated',{detail:cart}));
      if(window.jQuery)window.jQuery(document).trigger('cc-cart-refresh');
      setTimeout(close,650);
    } catch(e) {setStatus(e.message);}finally{updatePurchase();}
  });
  function saved() {try {const data=JSON.parse(localStorage.getItem('activeBasicsWishlist')||'[]');return Array.isArray(data)?data:[];}catch(e){return [];}}
  function syncSaved() {const items=saved();document.querySelectorAll('[data-ab9-wishlist]').forEach(button=>button.setAttribute('aria-pressed',items.includes(button.dataset.ab9Wishlist)?'true':'false'));}
  document.addEventListener('click',event=> {
    const button=event.target.closest('[data-ab9-open]');if(button){event.preventDefault();open(button).catch(e=>{window.location.href=url('products/'+button.dataset.ab9Open);});return;}
    const save=event.target.closest('[data-ab9-wishlist]');if(save){event.preventDefault();const items=saved(),handle=save.dataset.ab9Wishlist; const i=items.indexOf(handle);if(i<0)items.push(handle);else items.splice(i,1);try{localStorage.setItem('activeBasicsWishlist',JSON.stringify(items));}catch(e){}syncSaved();}
    const tab=event.target.closest('[data-ab-mobile-tab]');if(tab){const drawer=tab.closest('.mobile-navigation-drawer');if(!drawer)return;drawer.querySelectorAll('[data-ab-mobile-tab]').forEach(t=>{const active=t===tab;t.classList.toggle('is-active',active);t.setAttribute('aria-selected',active?'true':'false');});drawer.querySelectorAll('[data-ab-mobile-panel]').forEach(p=>{const active=p.dataset.abMobilePanel===tab.dataset.abMobileTab;p.hidden=!active;p.classList.toggle('is-active',active);});}
  });
  function enhanceProductColours() {
    document.querySelectorAll('[data-ab-v9-product]').forEach(root => {
      if(root.querySelector('.ab9-product-colour-family'))return;
      let p;try{p=JSON.parse(root.querySelector('script[id^="ProductJson-"]').textContent);}catch(e){return;}
      if(options(p).some(o=>/colou?r/i.test(o.name)))return;
      const group=map[p.handle];if(!group)return;
      const form=root.querySelector('form.product-purchase-form');if(!form)return;
      const selected=group.find(x=>x.handle===p.handle);
      const host=element('div',{className:'ab9-product-colour-family'});
      host.append(element('p',{},'Colour: '+(selected?.colour || '')));
      const links=element('div',{className:'ab9-card-swatches'});
      group.forEach(x=>{const a=element('a',{href:url('products/'+x.handle),title:x.colour});a.setAttribute('aria-label',x.colour);a.setAttribute('aria-current',x.handle===p.handle?'true':'false');a.style.background=x.hex;links.append(a);});host.append(links);form.prepend(host);
    });
  }
  function enhanceLooks() {
    document.querySelectorAll('[data-ab-v9-look-row]').forEach(row => {
      const siblings=map[row.dataset.productHandle];
      if(!siblings || row.querySelector('[data-ab9-look-colour]'))return;
      const controls=row.querySelector('.ab-v9-look-row__controls');if(!controls)return;
      const label=element('label',{className:'ab-v9-look-option ab9-look-colour'});label.append(element('span',{},'Colour'));
      const select=element('select');select.dataset.ab9LookColour='true';select.setAttribute('aria-label','Choose colour');
      siblings.forEach(s=>{const o=element('option',{value:s.handle},s.colour);o.selected=s.handle===row.dataset.productHandle;select.append(o);});label.append(select);controls.prepend(label);
      select.addEventListener('change',async()=>{
        select.disabled=true;const status=row.querySelector('[data-ab-v9-look-status]');status.textContent='Loading colour…';
        try {
          const p=await loadProduct(select.value);const clone=row.cloneNode(true);clone.dataset.productHandle=p.handle;clone.dataset.productId=p.id;
          const image=clone.querySelector('.ab-v9-look-row__image img');if(image){image.src=images(p)[0];image.alt=p.title;}
          clone.querySelectorAll('.ab-v9-look-row__image,.ab-v9-look-row__title').forEach(a=>a.href=url('products/'+p.handle));
          clone.querySelector('.ab-v9-look-row__title').textContent=p.title;
          const first=p.variants.find(v=>v.available)||p.variants[0];
          clone.querySelector('[data-ab-v9-look-price]').textContent=money(first.price);
          clone.querySelector('[data-ab-v9-look-id]').value=first.id;
          const data=clone.querySelector('[data-ab-v9-look-data]');data.textContent=JSON.stringify(p.variants.map(v=>({...v,priceText:money(v.price)})));
          const opts=clone.querySelector('.ab-v9-look-row__controls');opts.querySelectorAll('.ab-v9-look-option').forEach(l=>l.remove());
          options(p).forEach((o,i)=>{
            if(o.name==='Title' && o.values.length===1 && o.values[0]==='Default Title')return;
            const l=element('label',{className:'ab-v9-look-option'});l.append(element('span',{},o.name));const s=element('select');s.dataset.abV9LookOption='';s.dataset.optionIndex=i;s.setAttribute('aria-label',o.name);
            o.values.forEach(v=>{const item=element('option',{value:v},v);item.selected=v===first.options[i];s.append(item);});l.append(s);opts.insertBefore(l,opts.querySelector('[data-ab-v9-look-add]'));
          });
          clone.querySelector('[data-ab-v9-look-status]').textContent='';row.replaceWith(clone);
          window.ABV9Product?.init(document);enhanceLooks();
        }catch(e){status.textContent=e.message;select.disabled=false;select.value=row.dataset.productHandle;}
      });
    });
  }
  // Product-card colour rows only: full product and Quick Add palettes stay intact.
  const swatchStates = new WeakMap();
  const watchedSwatches = new Set();
  const swatchObserver = typeof ResizeObserver === 'function'
    ? new ResizeObserver(entries => entries.forEach(entry => queueSwatches(entry.target)))
    : null;

  function queueSwatches(host) {
    const state = swatchStates.get(host);
    if (!state || state.queued) return;
    state.queued = true;
    requestAnimationFrame(() => {
      state.queued = false;
      if (host.isConnected) measureSwatches(host, state);
    });
  }

  function measureSwatches(host, state) {
    const links = Array.from(host.children).filter(el => el.tagName === 'A' && !el.classList.contains('ab9-swatch-more'));
    if (!links.length) return;
    const style = getComputedStyle(host);
    const number = value => parseFloat(value) || 0;
    const width = host.getBoundingClientRect().width
      - number(style.paddingLeft) - number(style.paddingRight)
      - number(style.borderLeftWidth) - number(style.borderRightWidth);
    if (width <= 0) return;
    const sample = links.find(link => !link.hidden) || links[0];
    const dotStyle = getComputedStyle(sample);
    const dot = sample.getBoundingClientRect();
    const itemWidth = dot.width || number(dotStyle.width);
    const itemHeight = dot.height || number(dotStyle.height);
    if (!itemWidth || !itemHeight) return;
    const columnGap = number(style.columnGap);
    const perRow = Math.max(1, Math.floor((width + columnGap + 0.05) / (itemWidth + columnGap)));
    const capacity = perRow;
    const overflowing = links.length > capacity;
    const visibleCount = overflowing ? capacity - 1 : links.length;
    const keep = new Set(links.slice(0, visibleCount));
    const selected = links.find(link => link.getAttribute('aria-current') === 'true');
    if (selected && !keep.has(selected) && visibleCount > 0) {
      keep.delete(links[visibleCount - 1]);
      keep.add(selected);
    }
    links.forEach(link => { link.hidden = !keep.has(link); });
    host.style.setProperty('--ab9-swatch-more-size', itemWidth + 'px');
    // Reserve exactly one row; the last slot becomes a product-page + link on overflow.
    host.style.removeProperty('--ab9-swatch-two-rows');
    host.style.setProperty('--ab9-swatch-row-height', itemHeight + 'px');
    host.classList.add('ab9-swatches-limited');
    if (overflowing) {
      if (!state.more) {
        const data = cardData(state.card);
        const productLink = state.card.querySelector('a[href*="/products/"]');
        const href = data?.handle ? url('products/' + data.handle) : productLink?.href;
        if (!href) return;
        state.more = element('a', {className: 'ab9-swatch-more', href, title: 'View all colours'}, '+');
        host.append(state.more);
      }
      state.more.setAttribute('aria-label', 'View all ' + links.length + ' colours');
      state.more.hidden = false;
    } else if (state.more) {
      state.more.hidden = true;
    }
  }

  function capCardSwatches(host, card) {
    let state = swatchStates.get(host);
    if (!state) {
      state = {card, more: host.querySelector('.ab9-swatch-more'), queued: false};
      swatchStates.set(host, state);
      watchedSwatches.add(host);
      swatchObserver?.observe(host);
    }
    measureSwatches(host, state);
  }

  window.addEventListener('resize', () => watchedSwatches.forEach(queueSwatches), {passive: true});
  function enhanceCards() {
    document.querySelectorAll('.ab9-product-card').forEach(card=> {
      const p=cardData(card);if(!p)return;const group=map[p.handle];
      if(group && !card.querySelector('.ab9-card-swatches')) {
        const title=card.querySelector('.product-block__title');if(title)title.textContent=group[0].style;
        const host=card.querySelector('.product-info .innerer');if(host){const swatches=element('div',{className:'ab9-card-swatches'});swatches.setAttribute('aria-label','Available colours');group.forEach(x=>{const a=element('a',{href:url('products/'+x.handle),title:x.colour});a.setAttribute('aria-label',x.colour);a.setAttribute('aria-current',x.handle===p.handle?'true':'false');a.style.background=x.hex;swatches.append(a);});host.append(swatches);}
      }
      const cardSwatches = card.querySelector('.ab9-card-swatches');
      if (cardSwatches) capCardSwatches(cardSwatches, card);
      const media=card.querySelector('[data-ab9-cycle]');if(!media || media.dataset.ready)return;media.dataset.ready='true';
      const photos=[...media.querySelectorAll('img')];let index=0,timer=null;
      if(photos.length && !photos.some(x=>x.classList.contains('is-active')))photos[0].classList.add('is-active');
      async function show(next){const image=photos[next];if(!image)return;try{await image.decode();}catch(e){return;}photos.forEach(x=>x.classList.toggle('is-active',x===image));index=next;}
      const stop=()=>{clearInterval(timer);timer=null;};
      card.addEventListener('pointerenter',event=>{if(event.pointerType!=='mouse' || photos.length<2 || matchMedia('(prefers-reduced-motion:reduce)').matches)return;stop();photos.forEach(x=>{x.loading='eager';});timer=setInterval(()=>show((index+1)%photos.length),1400);});
      card.addEventListener('pointerleave',()=>{stop();show(0);});
      let start=null;media.addEventListener('touchstart',e=>{start=e.touches[0].clientX;},{passive:true});media.addEventListener('touchend',e=>{if(start===null)return;const dx=e.changedTouches[0].clientX-start;if(Math.abs(dx)>35){show((index+(dx<0?1:photos.length-1))%photos.length);const link=media.closest('a');const cancel=ev=>{ev.preventDefault();link.removeEventListener('click',cancel);};link.addEventListener('click',cancel,{once:true});setTimeout(()=>link.removeEventListener('click',cancel),400);}start=null;},{passive:true});
    });
    watchedSwatches.forEach(host => {
      if (!host.isConnected) {
        swatchObserver?.unobserve(host);
        watchedSwatches.delete(host);
      }
    });
    syncSaved();enhanceLooks();enhanceProductColours();
  }
  enhanceCards();
  let pending;new MutationObserver(()=>{clearTimeout(pending);pending=setTimeout(enhanceCards,80);}).observe(document.querySelector('#content') || document.body,{childList:true,subtree:true});
  document.addEventListener('shopify:section:load',enhanceCards);
})();
